export const GENIUS_LSQ_SOURCE = "Genius Website";

/** LSQ compact phone: 919876543210 (ISD + number, no + or dash) */
export const formatLsqPhoneDigits = (isdCode, phone) => {
  const cleanIsd = isdCode?.toString().replace(/\D/g, "") || "91";
  const cleanPhone = phone?.toString().replace(/\D/g, "") || "";
  return `${cleanIsd}${cleanPhone}`;
};

/** Top-level payload phone: 10-digit mobile only (no ISD prefix) */
const formatLsqPhoneLocal = (phone) => phone?.toString().replace(/\D/g, "").slice(-10) || "";

const formatActivityDateTime = (date = new Date()) => {
  const pad = (value) => String(value).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};

const omitEmptyFields = (fields) =>
  Object.fromEntries(
    Object.entries(fields).filter(([, value]) => value !== null && value !== undefined && value !== "")
  );

export const buildStudentLsqPayload = ({
  phone,
  firstName,
  lastName,
  grade,
  gradeId,
  schoolName,
  state,
  city
}) => {
  const phoneDigits = formatLsqPhoneDigits("+91", phone);
  const phoneLocal = formatLsqPhoneLocal(phone);
  const resolvedGradeId = gradeId?.toString() || grade?.toString().replace(/\D/g, "") || "";

  return {
    mode: "LSQ",
    type: "LEAD_ACTIVITY",
    phone: phoneLocal,
    ActivityDateTime: formatActivityDateTime(),
    FirstName: firstName ?? "",
    LastName: lastName ?? "",
    GradeID: resolvedGradeId,
    LeadFields: omitEmptyFields({
      mx_School_Name: schoolName,
      mx_School_City: city,
      mx_State_Name: state,
      mx_Grade: resolvedGradeId
    }),
    ActivityFields: omitEmptyFields({
      mx_Custom_1: grade,
      mx_Custom_2: phoneDigits,
      mx_Custom_3: schoolName,
      mx_Custom_4: state,
      mx_Custom_6: city,
      mx_Custom_7: GENIUS_LSQ_SOURCE
    })
  };
};

export const buildBrochureLsqPayload = ({
  phone,
  firstName,
  lastName,
  email,
  role,
  school,
  state,
  activityCode = 218
}) => {
  const phoneLocal = formatLsqPhoneLocal(phone);
  const fullName = `${firstName ?? ""} ${lastName ?? ""}`.trim();

  const leadDetail = (attribute, value) => ({ Attribute: attribute, Value: value ?? "" });
  const activityField = (schemaName, value) => ({ SchemaName: schemaName, Value: value ?? "" });

  return {
    LeadDetails: [
      leadDetail("EmailAddress", email),
      leadDetail("FirstName", firstName),
      leadDetail("LastName", lastName),
      leadDetail("Phone", phoneLocal),
      leadDetail("Source", GENIUS_LSQ_SOURCE),
      leadDetail("SearchBy", "EmailAddress")
    ],
    Activity: {
      ActivityEvent: activityCode,
      ActivityNote: "Genius Brochure Download",
      Fields: [
        activityField("mx_Custom_1", fullName),
        activityField("mx_Custom_2", school),
        activityField("mx_Custom_3", role),
        activityField("mx_Custom_4", state),
        activityField("mx_Custom_5", email)
      ]
    }
  };
};

export const buildSchoolLsqPayload = ({
  phone,
  firstName,
  lastName,
  email,
  role,
  name,
  school,
  city,
  state
}) => {
  const phoneDigits = formatLsqPhoneDigits("+91", phone);
  const phoneLocal = formatLsqPhoneLocal(phone);

  return {
    mode: "LSQ",
    type: "LEAD_ACTIVITY",
    phone: phoneLocal,
    ActivityDateTime: formatActivityDateTime(),
    FirstName: firstName ?? "",
    LastName: lastName ?? "",
    LeadFields: omitEmptyFields({
      EmailAddress: email,
      mx_Primary_POC_Designation: role,
      mx_School_Name: school,
      mx_School_City: city,
      mx_State_Name: state
    }),
    ActivityFields: omitEmptyFields({
      mx_Custom_1: role,
      mx_Custom_2: name,
      mx_Custom_3: school,
      mx_Custom_4: city,
      mx_Custom_5: state,
      mx_Custom_6: phoneDigits,
      mx_Custom_8: GENIUS_LSQ_SOURCE
    })
  };
};
